import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const ICON_SIZE = 32;

const styles = {
  rootContainer: css`
    display: flex;
    justify-content: center;
  `,
  rowContainer: css`
    max-width: 785px;
    flex: 1;
  `,
  item: css`
    display: block;
    flex: 1;
    overflow: hidden;
    flex-wrap: nowrap;

    * {
      user-select: none;
    }

     &:after, &:before {
      content: '';
      display: block;
      border-top: 2px solid ${COLORS.WHITE};
      position: absolute;
      top: 50%;
      margin-top: -${ICON_SIZE/2}px;
      width: 50%;
    }

     &:before {
      margin-right: ${ICON_SIZE*1.22}px;
      right: 50%;
    }

    &:after {
      margin-left: ${ICON_SIZE*1.22}px;
      left: 50%;
    }

    &:first-child:before,
    &:last-child:after{
      display: none;
    }

    &.active {
      &:after{
        border-top: 2px solid rgba(255,255,255,.3);
      }
    }

    &.checked {
      .icon {
        cursor: pointer;
        background-color: ${COLORS.WHITE};
        svg {
          display: block;
        }
      }
    }
    &.disabled {
      opacity: .7;
      &:before,
      &:after{
        border-top: 2px solid rgba(255,255,255,.4);
      }

      .icon {
        background-color: transparent;
        border: 2px solid rgba(255,255,255,.3);
        span {
          color: red;
        }
        svg {
        fill: transparent;
          display: block;
        }
      }
    }
  `,
  icon: css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: ${ICON_SIZE}px;
    width: ${ICON_SIZE}px;
    border-radius: 45px;
    background-color: rgba(255,255,255,.3);
    border: 2px solid ${COLORS.WHITE};
    margin: 0 auto 8px;
    transition: background-color 200ms ease-in-out;
    svg {
      display: none;
      position: relative;
      top: 1px;
      fill: ${COLORS.SEA_BLUE}
    }
  `,
  label: css`
    display: block;
    text-align: center;
    color: ${COLORS.WHITE};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
};

export default styles;
